import { RebarMaterialsClient } from "@api/apiClient";
import { useMutation, useQuery } from "@tanstack/react-query";
import axios from 'axios';

const rebarMaterialsClient = new RebarMaterialsClient(undefined, axios);

export const useRebarMaterials = (options?: any) => {
  return useQuery<string[]>({
    ...options,
    queryKey: ["rebarMaterials"],
    queryFn: async () => rebarMaterialsClient.getListOfRebarMaterialsValue(),
    placeholderData: [],
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes      
  });
};

export const useDeleteRebarMaterials = (options?: any) => {
  return useMutation<boolean, unknown, { type: string; value: string; }>({
    ...options,
    mutationFn: ({ value }) =>
      rebarMaterialsClient.deleteRebarMaterialValue(value),
  });
};

export const useAddRebarMaterials = (options?: any) => {
  return useMutation<{ type: string; value: string; }, unknown, { type: string; value: string; }>({
    ...options,
    mutationFn: ({ value }) =>
      rebarMaterialsClient.addRebarMaterialValue(value),
  });
};